import React, { useEffect, useState } from 'react'
import { LandingPageImport } from '../Import'
const { Card, Accordion, Nav, Tab, Clock4, event_img1, useNavigate, useDispatch, useSelector, Loader, moment, PerfectScrollbar, eventByDate } = LandingPageImport

export default function EventPlan() {

    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const event = useSelector(state => state?.eventByDate?.data)
    // console.log(event)

    useEffect(() => {
        setLoading(true)
        dispatch(eventByDate({ navigate })).finally(() => setLoading(false))
    }, [])

    return (
        <>
            <div className="event_plan padding-100">
                <div className="container">
                    <div className="row align-items-center">

                        <div className="col-lg-5">
                            <div className="event-images-area" data-aos="zoom-in" data-aos-duration="1000">
                                <div className="img1">
                                    <img src={event_img1} alt="event" />
                                </div>
                                <div className="content-area">
                                    <h5>Event Schedule</h5>
                                    <h2>Our Events Schedule Plan</h2>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7">
                            {loading ?
                                <div className="layout">
                                    <Loader />
                                </div>
                                :
                                event?.length ?
                                    <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
                                        <div className='row'>
                                            <div className='col-lg-3'>
                                                <Nav variant="pills" className="flex-column" data-aos="fade-up" data-aos-duration="900">
                                                    {event?.map((val, index) => (
                                                        <Nav.Item key={index}>
                                                            <Nav.Link eventKey={index} className='event_cal'>
                                                                <Card className="text-center">
                                                                    <Card.Header>{`Day 0${index + 1}`}</Card.Header>
                                                                    <Card.Body>
                                                                        <Card.Text>
                                                                            <span className='d-flex align-items-center justify-content-between'>
                                                                                <span className='date'>{val?.event_date && moment(val?.event_date).format('DD')}</span>
                                                                                <span className='month'>{val?.event_date && moment(val.event_date).format('MMM').toUpperCase()} <br />{val?.event_date && moment(val.event_date).format('YYYY')}</span>
                                                                            </span>
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    ))}
                                                </Nav>
                                            </div>
                                            <div className='col-lg-9'>
                                                <PerfectScrollbar style={{ height: '80vh' }} options={{ suppressScrollX: true }} >
                                                    <Tab.Content data-aos="fade-left" data-aos-duration="1200">
                                                        {event?.map((val, index) => (
                                                            <Tab.Pane eventKey={index} key={index}>
                                                                <Accordion defaultActiveKey={index} className='event_acc'>
                                                                    {val?.events?.map((event, eindex) => (
                                                                        <Accordion.Item eventKey={eindex} className='mb-3' key={index.toString() + eindex.toString()}>
                                                                            <Accordion.Header>
                                                                                <div className='time'><Clock4 size={20} className='me-2' />{`${event?.start_time && moment(event?.start_time, 'HH:mm:ss').format('LT')} - ${event?.end_time && moment(event?.end_time, 'HH:mm:ss').format('LT')}`}</div>
                                                                                <div className='title'>{event?.event_title}</div>
                                                                            </Accordion.Header>
                                                                            <Accordion.Body>
                                                                                {event?.description}
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                    ))}
                                                                </Accordion>
                                                            </Tab.Pane>
                                                        ))}
                                                    </Tab.Content>
                                                </PerfectScrollbar>
                                            </div>
                                        </div>
                                    </Tab.Container>
                                    :
                                    <div className='p-2 rounded d-flex justify-content-center align-items-center bg-body-secondary fw-medium'>
                                        No Events Found
                                    </div>
                            }
                        </div>

                    </div>
                </div>
            </div >
        </>
    )
}